import { motion } from "framer-motion";

// Import icons
import react from "../Images/Lang/react.png";
import js from "../Images/Lang/js.png";
import angular from "../Images/Lang/angular.png";
import vue from "../Images/Lang/vue.png";
import next from "../Images/Lang/next.png";
import node from "../Images/Lang/node.png";
import python from "../Images/Lang/python.png";
import java from "../Images/Lang/java.png";
import dotnet1 from "../Images/Lang/dotnet1.png";
import flutter from "../Images/Lang/flutter.png";
import swift from "../Images/Lang/swift.png";
import kotlin from "../Images/Lang/kotlin.png";
import aws from "../Images/Lang/aws.png";
import azure from "../Images/Lang/azure.png";
import gc from "../Images/Lang/gc.png";
import digital from "../Images/Lang/digital.png";
import mongodb from "../Images/Lang/mongodb.png";
import sql from "../Images/Lang/sql.png";
import mysql from "../Images/Lang/mysql.png";
import firebase from "../Images/Lang/firebase.png";

const topIcons = [
  { id: 1, src: react, alt: "React" },
  { id: 2, src: js, alt: "JavaScript" },
  { id: 3, src: angular, alt: "Angular" },
  { id: 4, src: vue, alt: "Vue" },
  { id: 5, src: next, alt: "Next.js" },
  { id: 6, src: node, alt: "Node.js" },
  { id: 7, src: python, alt: "Python" },
  { id: 8, src: java, alt: "Java" },
  { id: 9, src: dotnet1, alt: ".NET" },
  { id: 10, src: flutter, alt: "Flutter" },
];

const bottomIcons = [
  { id: 11, src: swift, alt: "Swift" },
  { id: 12, src: kotlin, alt: "Kotlin" },
  { id: 13, src: aws, alt: "AWS" },
  { id: 14, src: azure, alt: "Azure" },
  { id: 15, src: gc, alt: "Google Cloud" },
  { id: 16, src: digital, alt: "DigitalOcean" },
  { id: 17, src: mongodb, alt: "MongoDB" },
  { id: 18, src: sql, alt: "SQL" },
  { id: 19, src: mysql, alt: "MySQL" },
  { id: 20, src: firebase, alt: "Firebase" },
];

// Updated marquee animation
const marqueeVariants = {
  animate: {
    x: ["0%", "-50%"], // Shift halfway so it loops seamlessly
    transition: {
      x: {
        repeat: Infinity,
        repeatType: "loop",
        duration: 10, // Adjust speed (lower = faster)
        ease: "linear",
      },
    },
  },
};

// Reverse animation for bottom row
const reverseMarqueeVariants = {
  animate: {
    x: ["-50%", "0%"], // Moves in opposite direction
    transition: {
      x: {
        repeat: Infinity,
        repeatType: "loop",
        duration: 10,
        ease: "linear",
      },
    },
  },
};

const Language = () => {
  return (
    <div className="bg-[#0F172B] py-10 overflow-hidden w-full">
      <div className="w-full space-y-10 overflow-hidden">
        {/* Top Row */}
        <div className="relative w-full overflow-hidden">
          <motion.div
            className="flex min-w-max space-x-10 sm:space-x-14 md:space-x-20 items-center"
            variants={marqueeVariants}
            animate="animate"
          >
            {[...topIcons, ...topIcons].map((icon, i) => (
              <div key={i} className="w-20 h-20 sm:w-20 sm:h-20 md:w-20 md:h-20 flex items-center justify-center">
                <img
                  src={icon.src}
                  alt={icon.alt}
                  className="object-contain grayscale hover:grayscale-0 w-full h-full"
                />
              </div>
            ))}
          </motion.div>
        </div>

        {/* Bottom Row */}
        <div className="relative w-full overflow-hidden">
          <motion.div
            className="flex min-w-max space-x-10 sm:space-x-14 md:space-x-20 items-center"
            variants={reverseMarqueeVariants}
            animate="animate"
          >
            {[...bottomIcons, ...bottomIcons].map((icon, i) => (
              <div key={i} className="w-20 h-20 sm:w-20 sm:h-20 md:w-20 md:h-20 flex items-center justify-center">
                <img
                  src={icon.src}
                  alt={icon.alt}
                  className="object-contain grayscale hover:grayscale-0 w-full h-full"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Language;
